import React, { useEffect, useState } from 'react';
import { mockData } from '../mockData';
import { TrendingUp, TrendingDown, DollarSign, Activity } from 'lucide-react';

const MarketTicker = () => {
  const [tickerItems, setTickerItems] = useState([]);

  useEffect(() => {
    const minerals = mockData.marketData.minerals.map(item => ({
      ...item,
      type: 'mineral',
      icon: DollarSign
    }));
    
    const indicators = mockData.marketData.economicIndicators.map(item => ({
      ...item,
      type: 'indicator',
      icon: Activity
    }));

    const combined = [];
    const maxLength = Math.max(minerals.length, indicators.length);
    
    for (let i = 0; i < maxLength; i++) {
      if (minerals[i]) combined.push(minerals[i]);
      if (indicators[i]) combined.push(indicators[i]);
    }

    setTickerItems([...combined, ...combined]);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTickerItems(prevItems => 
        prevItems.map(item => ({
          ...item,
          change: item.change + (Math.random() - 0.5) * 0.5
        }))
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const formatValue = (item) => {
    if (item.type === 'mineral') {
      return `${item.price.toLocaleString()} ${item.unit}`;
    } else {
      return `${item.value}${item.unit}`;
    }
  };

  return (
    <div className="bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 border-b border-blue-800 overflow-hidden relative">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-500/5 to-transparent animate-shimmer"></div>
      
      <div className="relative py-3">
        <div className="flex animate-scroll-infinite">
          {tickerItems.map((item, index) => (
            <div 
              key={index} 
              className="flex items-center gap-2 px-6 border-r border-blue-800/30 whitespace-nowrap group hover:bg-blue-900/20 transition-colors duration-300"
            >
              <item.icon className="w-4 h-4 text-blue-400 flex-shrink-0" />
              
              <div className="flex items-center gap-1.5">
                <span className="text-xs font-semibold text-blue-100 uppercase tracking-wide">
                  {item.name}
                </span>
                <span className="text-[10px] text-blue-300/60 font-medium">
                  {item.country}
                </span>
              </div>
              
              <div className="w-px h-3 bg-blue-700/40"></div>
              
              <span className="text-sm font-bold text-white">
                {formatValue(item)}
              </span>
              
              <div className={`flex items-center gap-0.5 ${
                item.change >= 0 ? 'text-green-400' : 'text-red-400'
              }`}>
                {item.change >= 0 ? (
                  <TrendingUp className="w-3 h-3" />
                ) : (
                  <TrendingDown className="w-3 h-3" />
                )}
                <span className="text-xs font-semibold">
                  {Math.abs(item.change).toFixed(2)}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-slate-900 to-transparent pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-slate-900 to-transparent pointer-events-none"></div>
    </div>
  );
};

export default MarketTicker;
